/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Override_Bitrate_LabelInputs */



/**
* | output |
* | --- |
* | "Override Target Bitrate" |
*
* @param {Drastic_Tech_Override_Bitrate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_override_bitrate_label = /** @type {((inputs?: Drastic_Tech_Override_Bitrate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Override_Bitrate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacer le debit cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielbitrate überschreiben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituisci il bitrate di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменить целевой битрейт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anular la tasa de bits objetivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("覆盖目标比特率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲットビットレートを上書き")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य बिटरेट को ओवरराइड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Substituir taxa de bits alvo")
	return /** @type {LocalizedString} */ ("Override Target Bitrate")
});